import React from "react";

export default function LoadingMessage({ msg, forwardRef }) {
  return (
    <div className="row my-3 d-none w-100" ref={forwardRef}>
      <h5 className="text-center w-100">{msg}</h5>
    </div>
  );
}
